module.exports = __webpack_public_path__ + "img/icon_bsite_white.88b7bfb9.svg";